import React, { useState } from 'react';
import { Box, IconButton, SwipeableDrawer } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import Menu from './Menu';

const MobileMenu = ({ setMenu, menu, drawerOpen, setDrawerOpen, setSearchClicked }) => {

    function toggleDrawer(){
        setDrawerOpen(!drawerOpen);
        setSearchClicked(false);
    }

    return (
        <>
            <IconButton
                onClick={() => toggleDrawer()}
                sx={{
                    color: theme => theme.palette.secondary.contrastText,
                    background: theme => theme.palette.secondary.main,
                    width: '52px',
                    height: '52px',
                    '&:hover': {
                        background: theme => theme.palette.secondary.dark
                    }
                }}
            >
                {drawerOpen?
                    <CloseIcon/>
                :
                    <MenuIcon/>
                }
            </IconButton>
            <SwipeableDrawer
                anchor="right"
                open={drawerOpen}
                onClose={() => toggleDrawer()}
                elevation={9}
                PaperProps={{
                    sx: {
                        background: theme => theme.palette.background.header
                    }
                }}
            >
                <Box 
                    sx={{
                        mt:'100px',
                        height:window.innerHeight-100+'px',
                        width: '90vw',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent:'center',
                        backgroundColor: theme => theme.palette.background.header
                    }}
                >
                    <Menu toggleDrawer={toggleDrawer} setMenu={setMenu} menu={menu} />
                </Box>
            </SwipeableDrawer>
        </>
    );
};

export default MobileMenu;
